import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { visuallyHidden } from '~/components/Utilities';
import styles from './TripCard.module.css';
import type { TripCardCtaProps } from './TripCard.types';
const TripCardCta = t0 => {
  const $ = _c(11);
  const {
    isLoading
  } = t0;
  const t = useTranslations();
  let t1;
  if ($[0] !== isLoading || $[1] !== t) {
    t1 = isLoading && <output className={visuallyHidden} aria-label={t("common.loading")} />;
    $[0] = isLoading;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isLoading || $[4] !== t) {
    t2 = isLoading ? <span className={styles.dotFlashing} /> : t("common.trip_card_cta");
    $[3] = isLoading;
    $[4] = t;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t2) {
    t3 = <span aria-hidden="true" data-test-id="trip-card-cta" className={styles.cta}>{t2}</span>;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t3) {
    t4 = <>{t1}{t3}</>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return t4;
};
export { TripCardCta };